import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";
import router from "@/router";
import { useScroll } from "@vueuse/core";


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthLayout',
  setup(__props, { expose }) {
  expose();

const refScrollBlock = ref<HTMLElement | null>();
const { arrivedState } = useScroll(refScrollBlock);

const getImgBg = computed(() => {
  return router.currentRoute.value.meta.imgBg || "eric-photo2.png";
});

const currentRoute = computed(() => {
  return router.currentRoute.value.name;
});

const getBottomArrived = computed(() => {
  return arrivedState.bottom;
});

const __returned__ = { refScrollBlock, arrivedState, getImgBg, currentRoute, getBottomArrived, computed, ref, router, useScroll }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})